import { mergeMap } from 'rxjs/operators';
import { IEpic, isTypeOfAndGetPayload } from '@cbridge-utils/redux-observable';
import { downloadFileFromResponse } from '@cbridge-utils/file';
import { catchApiError, IClientApiDependencySegment } from '@cbridge-packages/api';
import { createApiErrorNotification } from '@cbridge-packages/notification';
import { toApiSort } from '@cbridge-utils/datagrid';
import { MarkupAction } from '../markup.action';

type IDependencies = IClientApiDependencySegment;

export const exportMarkupListEpic: IEpic<{}, IDependencies> = (action$, _, dependencies) => action$.pipe(
  isTypeOfAndGetPayload(MarkupAction.exportFile.started),
  mergeMap((params) => {
    const { sort, ...payload } = params;

    return dependencies.api.exportMarkupsFile({
      ...payload,
      sort: toApiSort(sort),
    }).pipe(
      mergeMap((response) => {
        downloadFileFromResponse(response);
        return [];
      }),
      catchApiError((error) => {
        return [
          MarkupAction.exportFile.failed({ params, error }),
          createApiErrorNotification(error),
        ];
      }),
    );
  }),
);
